<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<v-layout row wrap>
					<v-flex xs12>
						<filter-reservation v-model="filter" :outlets="outlets" :customers="customers" @filter="onFilter()"></filter-reservation>
					</v-flex>
					<v-flex xs12>
						<v-card>
							<v-card-title>
								Reservation Table
								<v-spacer></v-spacer>
								<v-btn color="primary" :href="$route(
							'tenant.reservations.print.index',
							{
								tenant: $page.props.tenant.id,
								'filter[status]':
									this.filter.status,
								'filter[code]':
									this.filter.code,
								'filter[outlet_id]':
									this.filter.outlet_id,
								'filter[customer_id]':
									this.filter.customer_id,
								'filter[range]':
									this.filter.range,
							}
						)
							" target="_blank">
									<v-icon left>mdi-printer</v-icon>
									{{ $t("label.print") }}
								</v-btn>
								<v-btn :href="$route(
							'tenant.reservations.export.reservation',
							{
								tenant: $page.props.tenant.id,
								'filter[status]':
									this.filter.status,
								'filter[code]':
									this.filter.code,
								'filter[outlet_id]':
									this.filter.outlet_id,
								'filter[customer_id]':
									this.filter.customer_id,
								'filter[range]':
									this.filter.range,
							}
						)
							" target="_blank" color="success" class="ml-3">
									<v-icon left>mdi-file-excel</v-icon>
									{{ $t("label.export") }}</v-btn>
								<v-btn class="ml-3" @click="
							$inertia.visit(
								$route(
									'tenant.reservations.create',
									$page.props.tenant.id
								)
							)
							" :permission="'create reservations'">
									<v-icon left>mdi-plus</v-icon>
									{{ $t("Create") }}
								</v-btn>
							</v-card-title>
							<v-divider></v-divider>
							<v-card-text>
								<table class="reservation-table elevation-1" style="
										width: auto !important;
										min-width: 100% !important;
										overflow-x: scroll !important;
										display: block;
										white-space: nowrap;
									">
									<thead>
										<tr>
											<th style="width: 110px">
												{{ $t("label.actions") }}
											</th>
											<th scope="col" width="10px">#</th>
											<th scope="col">
												{{ $t("Status") }}
											</th>
											<th scope="col">
												{{ $t("Code") }}
											</th>
											<th scope="col" style="width: 150px">
												{{ $t("Outlet") }}
											</th>
											<th scope="col" style="min-width: 150px">
												{{ $t("Customer") }}
											</th>
											<th scope="col" style="width: 150px">
												{{ $t("Date") }}
											</th>
											<th scope="col" style="width: 120px">
												{{ $t("Time") }}
											</th>
											<th scope="col">
												{{ $t("Adults") }}
											</th>
											<th scope="col">
												{{ $t("Children") }}
											</th>
											<th scope="col" width="100px">
												{{ $t("Table") }}
											</th>
											<th scope="col" width="300px">
												{{ $t("Comment") }}
											</th>
											<th scope="col">
												{{ $t("Booked at") }}
											</th>
										</tr>
									</thead>
									<tbody>
										<template v-if="data.length != 0">
											<template v-for="(
													reservations, key
												) in data">
												<tr style="
														background-color: #e3e3e3;
													" :key="'header_' + key">
													<td colspan="8">
														<strong>{{ key }}</strong>
													</td>
													<td colspan="2">
														<strong>
															{{ $t("label.total_pax") }}:
															<!-- sum adults and children  -->
															{{
							reservations.reduce(
								(
									acc,
									reservation
								) => {
									return (
										acc +
										reservation.adults +
										reservation.children
									);
								},
								0
							)
						}}
														</strong>
													</td>
													<td colspan="3">
														<strong>
															{{ $t("Total Reservations") }}:
															{{ reservations.length }}
														</strong>
													</td>
												</tr>
												<tr v-for="(
														reservation, index
													) in reservations" :key="'header_' +
							key +
							'_' +
							index
							">
													<td>
														<v-tooltip bottom>
															<template v-slot:activator="{
							on,
							attrs,
						}">
																<Link as="v-btn" icon v-bind="attrs
							" v-on="on" dense :href="$route(
							'tenant.reservations.show',
							{
								tenant: $page
									.props
									.tenant
									.id,
								reservation:
									reservation.uuid,
							}
						)
							"><v-icon>mdi-eye</v-icon></Link>
															</template>
															<span>{{
							$t("View")
						}}</span>
														</v-tooltip>
														<v-tooltip bottom>
															<template v-slot:activator="{
								on,
								attrs,
							}">
																<Link as="v-btn" icon v-bind="attrs
							" v-on="on" dense :href="$route(
							'tenant.reservations.edit',
							{
								tenant: $page
									.props
									.tenant
									.id,
								reservation:
									reservation.uuid,
							}
						)
							"><v-icon>mdi-pencil</v-icon></Link>
															</template>
															<span>{{ $t("Edit") }}</span>
														</v-tooltip>
													</td>
													<td style="
															text-align: center;
														">
														<!-- order number of current row -->
														{{ index + 1 }}
													</td>
													<td style="
															text-align: center;
														">
														<v-chip :color="reservation.status_color" dark small>
															{{ reservation.status_label }}
														</v-chip>
													</td>
													<td style="
															text-align: center;
														">
														{{ reservation.code }}
													</td>
													<td>
														{{ reservation.outlet_name }}
													</td>
													<td>
														{{ reservation.customer_name }}
														<br />
														{{ reservation.customer_phone }}
														<br />
														{{ reservation.customer_email }}
														<p>
															<v-chip x-small v-if="reservation.is_returning_customer" color="success" @click="markAsReturningCustomer(reservation, false)">
																{{ $t("Returning Customer") }}
															</v-chip>
															<v-chip x-small v-else color="warning" @click="markAsReturningCustomer(reservation, true)">
																{{ $t("New Customer") }}
															</v-chip>
														</p>
													</td>
													<td style="text-align: center;">
														{{ reservation.date }}
													</td>
													<td style="text-align: center;">
														{{ reservation.time }}
													</td>
													<td style="text-align: center;">
														{{ reservation.adults }}
													</td>
													<td style="text-align: center;">
														{{ reservation.children }}
													</td>
													<td>
														{{ reservation.table_names }}
													</td>
													<td>
														{{ reservation.description }}
													</td>
													<td>
														{{ reservation.formatted_created_at }}
													</td>
												</tr>
											</template>
										</template>
										<template v-else>
											<tr>
												<td colspan="13" class="text-center">
													<strong>
														{{ $t("No reservation found.") }}
													</strong>
												</td>
											</tr>
										</template>
									</tbody>
								</table>
							</v-card-text>
						</v-card>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>

		<app-tenant-delete-dialog ref="deleteDialog" :endpoint="'tenant.reservations.destroy'" :uuid="item.uuid" :data="{ reservation: item.uuid, tenant: $page.props.tenant.id}">
		</app-tenant-delete-dialog>
	</v-container>
</template>

<script>
	import moment from "moment";
	import { Link } from "@inertiajs/inertia-vue";
	export default {
		props: ["data", "outlets", "customers"],
		remember: {
			data: ["filter"],
			key: "Reservations/Index",
		},
		data() {
			return {
				panel: [0],
				filter: {
					range: {
						startDate: new moment().format("YYYY-MM-DD"),
						endDate: new moment().format("YYYY-MM-DD"),
					},
				},
				item: {},
				count: 1,
			};
		},
		components: {
			Link,
		},
		computed: {
			endpoint() {
				return this.$route(
					"tenant.reservations.index",
					this.$page.props.tenant.id
				);
			},
		},
		methods: {
			onFilter() {
				this.$inertia.reload({
					only: ["data"],
					data: {
						filter: this.filter,
					},
				});
			},
			editItem(item) {
				this.$inertia.visit(
					this.$route("tenant.reservations.edit", {
						tenant: this.$page.props.tenant.id,
						reservation: item.uuid,
					})
				);
			},
			viewItem(item) {
				this.$inertia.visit(
					this.$route("tenant.reservations.show", {
						tenant: this.$page.props.tenant.id,
						reservation: item.uuid,
					})
				);
			},
			deleteItem(item) {
				this.item = Object.assign({}, item);
				this.$refs.deleteDialog.open();
			},

			markAsReturningCustomer(item, isReturning) {
				axios.post(
					this.$route("tenant.reservations.mark_as_returning_customer", {
						tenant: this.$page.props.tenant.id,
						reservation: item.uuid,
						is_returning_customer: isReturning,
					}),
				).then((response) => {
					this.$inertia.reload();
				});
			},
		},
	};
</script>

<style scoped>
	.reservation-table {
		font-size: 10px !important;
		font-family: "Poppins", sans-serif;
		width: 100%;
		border-collapse: collapse;
		background-color: #fff;
	}

	.reservation-table tr,
	.reservation-table td,
	.reservation-table th {
		padding: 5px !important;
		border: 1px solid #ddd;
	}
</style>